export default "__VITE_ASSET__pc$kkg2C__"